import { h } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper';
import Media from 'utils/media';
import { isLauraCanada, generateUrl } from 'utils/helpers';
import IconArrow from 'utils/icon/icon-chevron-right.svg';
import { useRef, useEffect } from 'preact/hooks';
import ProductBadge from '../product/product-badge';

const ProductGalleryQuickView = ({
  currentProduct: { media, badges, handle },
}) => {
  const sliderRef = useRef(null);

  useEffect(() => {
    document.addEventListener('variant:change', () => {
      if (sliderRef.current) {
        sliderRef.current.swiper.slideTo(0);
      }
    });

    return () => {
      document.removeEventListener('variant:change', () => {
        if (sliderRef.current) {
          sliderRef.current.swiper.slideTo(0);
        }
      });
    };
  }, []);

  const handleImageClick = () => {
    const pdpUrl = generateUrl(handle, 'products');
    if (pdpUrl) {
      window.location.href = pdpUrl;
    }
  };

  return (
    <div className="relative">
      <Swiper
        ref={sliderRef}
        modules={[Navigation, FreeMode]}
        slidesPerView={'auto'}
        freeMode={true}
        spaceBetween={isLauraCanada ? 4 : 8}
        navigation={{
          nextEl: '[data-product-slide-next]',
          prevEl: '[data-product-slide-prev]',
        }}
        className="product-carousel"
      >
        {media.map((img, index) => (
          <SwiperSlide
            key={img.id}
            className="!w-[164px] md:!w-[187px] !h-auto"
            onClick={handleImageClick}
          >
            {index === 0 && <ProductBadge badges={badges?.value} />}
            <Media
              {...img}
              isQuickView={true}
              // eslint-disable-next-line no-unneeded-ternary
              lazyLoad={index <= 2 ? false : true}
              srcWidths={{ sm: 640 }}
              autoPlay={true}
              parentClass="h-full"
              className="h-full object-cover cursor-pointer"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        className="absolute right-8 z-10 hidden top-1/2 -translate-y-1/2
          disabled:opacity-0 bg-white w-24 h-24 [&>svg]:w-9 [&>svg]:h-9 ml:[&>svg]:w-12 ml:[&>svg]:h-12
          lc:rounded-full items-center justify-center md:flex"
        data-product-slide-next
        type="button"
        aria-label={window.TMW.Strings.icons.arrowRight}
      >
        <IconArrow stroke={1} />
      </button>
      <button
        className="absolute left-8 z-10 hidden top-1/2 -translate-y-1/2
          disabled:opacity-0 bg-white w-24 h-24 [&>svg]:relative [&>svg]:w-9 [&>svg]:h-9
          ml:[&>svg]:w-12 ml:[&>svg]:h-12 [&>svg]:rotate-180 [&>svg]:-left-1
          lc:rounded-full items-center justify-center md:flex"
        data-product-slide-prev
        type="button"
        aria-label={window.TMW.Strings.icons.arrowLeft}
      >
        <IconArrow stroke={1} />
      </button>
    </div>
  );
};

export default ProductGalleryQuickView;
